<template>
    <v-dialog v-model="ui.display" width="600">
        <div class="graph_range_picker" v-if="ui.display==true">
            <header>
                <h1>{{parameter.reference.descrizione}}</h1>
                <GraphSVG name="close" @click="close"  />
            </header>
            <main>
                <div>
                    <h2>Data di riferimento</h2>
                    <input type="date" />
                </div>
                <div>
                    <h2>Offset</h2>
                    <label v-for="(option, i) in ui.options" :key="i">
                        <input type="radio" name="graph_range_picker_opt" :value="option.value" />
                        <span>
                            {{option.text}}
                        </span>
                    </label>
                </div>
                                   
            </main>
            <footer>
                <span @click="save">APPLICA</span>
            </footer>           
        </div>
    </v-dialog>
</template>
<script>
import GraphSVG from "@/components/GRAPH/Generale/Componenti/SVG/SVG.vue";
export default {
    name:'GraphDateRangePicker',
    components : {
        GraphSVG
    },
    data(){
        return{
            parameter : {
                clone : null,
                reference : null
            },
            ui : {
                display : false,
                options : [
                    { text:'-1 anno', value: 0, custom: false },
                    { text:'-6 mesi', value: 1, custom: false },
                    { text:'-3 mesi', value: 2, custom: false },
                    { text:'-1 mese', value: 3, custom: false },
                    { text:'-15 giorni', value: 4, custom: false },
                    { text:'-1 settimana', value: 5, custom: false },
                    { text:'+1 settimana', value: 6, custom: false },
                    { text:'+15 giorni', value: 7, custom: false },
                    { text:'+1 mese', value: 8, custom: false },
                    { text:'+3 mesi', value: 9, custom: false },
                    { text:'+6 mesi', value: 10, custom: false },
                    { text:'+1 anno', value: 11, custom: false },
                    { text:'+1 anno', value: 12, custom: false }
                ]
            }
        }
    },
    methods : {
        close(){
            this.ui.display = false;
            Object.assign(this.parameter, {clone: null, reference: null});
        },
        open(item){
            Object.assign(this.parameter, {
                clone : JSON.parse(JSON.stringify(item)),
                reference : item
            });
            this.ui.display = true;
        },
        save(){
            this.parameter.reference.layout = this.parameter.clone.layout;
            this.close();
        }
    }
}
</script>
<style scoped>
.graph_range_picker{
    background-color: var(--widget_body_background);
    position: relative;
    width:100%;
    height:90vh;
    overflow: hidden;
    user-select: none;
}
.graph_range_picker > header{
    width:100%;
    background-color: var(--widget_title_background);
    color : var(--widget_title_text_color); 
    position: relative; 
}
.graph_range_picker > header > h1{
    line-height: 40px;
    height:40px;
    font-size: 18px;
    font-weight : normal;
    text-align: left;
    width:calc(100% - 10px);
    margin : 0 10px;
}
.graph_range_picker > header > svg{
    position: absolute;
    height:40px;
    right:10px;
    top:0px;
    cursor:pointer;
}
.graph_range_picker > main{
    width:100%;
    position: relative;
    height:calc(100% - 80px);
}
.graph_range_picker > footer{
    position: relative;
    height:40px;
    width:100%;
    padding:0 20px;
    border-top: 1px solid var(--widget_title_background);
    background-color: white;
    text-align: right;
    display:block;
}
.graph_range_picker > footer > span{
    display: inline-block;
    height:100%;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    color: var(--widget_title_background);
    cursor:pointer;
}


</style>